import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Twitter, Instagram, Linkedin, Send } from "lucide-react";
import { NAV_CATEGORIES, COMUNICAZIONI_SUB } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-sq-navy text-gray-300 mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <span className="font-serif-display text-2xl text-white">
            Società <span className="text-sq-orange">Quotate</span>
          </span>
          <p className="text-sm mt-3 leading-relaxed text-gray-400">
            Informazione finanziaria indipendente su mercati, banche, energia ed
            economia. Gestioni e bilanci in controluce.
          </p>
          <div className="flex gap-3 mt-5">
            {[Facebook, Twitter, Instagram, Linkedin, Send].map((Icon, i) => (
              <a
                key={i}
                href="#"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-sq-orange transition-colors"
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">
            Sezioni
          </h4>
          <ul className="space-y-2 text-sm">
            {NAV_CATEGORIES.map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/categoria/${c.slug}`}
                  className="hover:text-sq-orange transition-colors"
                >
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">
            Comunicazioni
          </h4>
          <ul className="space-y-2 text-sm">
            {COMUNICAZIONI_SUB.map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/comunicazioni/${c.slug}`}
                  className="hover:text-sq-orange transition-colors"
                >
                  {c.name}
                </Link>
              </li>
            ))}
            <li>
              <Link
                to="/societa"
                className="hover:text-sq-orange transition-colors"
              >
                Schede società quotate
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">
            Newsletter
          </h4>
          <p className="text-sm text-gray-400 mb-3">
            Ricevi le principali notizie finanziarie nella tua casella.
          </p>
          <div className="flex">
            <input
              type="email"
              placeholder="La tua email"
              className="flex-1 px-3 py-2 text-sm text-sq-navy rounded-l-sm outline-none"
            />
            <button className="bg-sq-orange hover:bg-sq-orange-dark transition-colors px-4 text-sm font-medium text-white rounded-r-sm">
              Iscriviti
            </button>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 text-xs text-gray-400 flex flex-col md:flex-row justify-between gap-2">
          <span>© 2026 Società Quotate — Tutti i diritti riservati.</span>
          <span>Testata di informazione finanziaria · societaquotate.it</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
